// extracted by mini-css-extract-plugin
export default {"tabWrapper":"Tabs_tabWrapper__cuSrG","tab":"Tabs_tab__rdxAi","selected":"Tabs_selected__FNqnX"};